import React from 'react';

import Metadata from '@pray/shared/components/Metadata';

import { Globus, Hourglass, FilePlay, Position } from 'components/pages/public/components/icons/benefits';
import { Albums } from 'components/pages/public/components/icons/features';
import { PRODUCT_LABELS, Products } from 'components/pages/public/types/products';
import { VIEW_EVENT_NAMES } from 'constants.js';

import { Header } from '../../../../components/Header/Header';
import ProductPageLayout from '../../layout/ProductPageLayout';

const SocialClipsPage: React.FC = () => {
  return (
    <div data-viewname={VIEW_EVENT_NAMES.PRODUCTS.SOCIAL_CLIPS}>
      <Metadata
        title={`Long Sermons into Viral Shorts | ${PRODUCT_LABELS[Products.PRAYSTUDIO]}`}
        description={`Transform long videos into viral shorts fast with ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        }'s Social Clips AI. Boost reach on TikTok, YouTube, & Reels!`}
      />
      <Header />
      <ProductPageLayout
        // Hero section
        tag={PRODUCT_LABELS[Products.SOCIAL_CLIPS]}
        icon={<Albums />}
        title={`Turn Sermons into Viral ${PRODUCT_LABELS[Products.SOCIAL_CLIPS]}`}
        description={`With ${
          PRODUCT_LABELS[Products.SOCIAL_CLIPS]
        }, you can easily turn your sermons into 60-second videos that reach hearts everywhere at the click of a button.`}
        ctaText="GET STARTED"
        heroMedia={{ type: 'image', src: 'https://d339bgihw9yfmi.cloudfront.net/web/images/social-clips-hero.png' }}
        // Benefits section
        benefitsSectionTitle={`Why ${PRODUCT_LABELS[Products.SOCIAL_CLIPS]}?`}
        benefits={[
          {
            icon: <Hourglass />,
            title: 'Save Time and Effort',
            description: `No fancy editing skill needed. ${
              PRODUCT_LABELS[Products.PRAYSTUDIO]
            }'s AI handles the heavy lifting so you can focus on ministry.`,
            linkText: 'LEARN MORE',
          },
          {
            icon: <Globus />,
            title: 'Expand Your Reach',
            description: 'Connect with more seekers on social media and grow your online ministry with ease.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <FilePlay />,
            title: 'Instant, Viral Clips',
            description: 'Turn your sermons into polished, shareable videos ready for Facebook, Instagram and TikTok.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <Position />,
            title: 'Stay Focused',
            description: 'Spend less time editing and more time serving your congregation and spreading God’s word.',
            linkText: 'LEARN MORE',
          },
        ]}
        // How it works section
        howItWorksSectionTitle="How it Works"
        steps={[
          {
            tag: 'STEP 1',
            title: 'Upload Your Sermon',
            description: `Share your full video sermon with ${PRODUCT_LABELS[Products.PRAYSTUDIO]}.`,
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/social-clips-benefit-step-1.png',
            imageAlt: 'Upload your sermon',
          },
          {
            tag: 'STEP 2',
            title: 'AI-Powered Editing',
            description: 'With just one click, our AI transforms your sermon into captivating short clips.',
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/social-clips-benefit-step-2.png',
            imageAlt: 'AI-Powered Editing',
          },
          {
            tag: 'STEP 3',
            title: 'Share as Social Content',
            description:
              'Instantly receive social-ready clips to share on platforms like Facebook, Instagram, and TikTok.',
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/social-clips-benefit-step-3.png',
            imageAlt: 'Share as social content',
          },
        ]}
        // Solution cards section
        solutionsSectionTitle="All-in-one Solution"
      />
    </div>
  );
};

export default SocialClipsPage;
